<template>
  <div class="content">
    <div class="basic">
      <div class="headline">
        <p class="title">
          {{title}}
        </p>
        <div class="info">
          <div class="left">
            <span class="name">发布者</span>
            <span>{{username}}</span>
          </div>
          <div class="seprate"></div>
          <div class="right">
            <span class="name">状态</span>
            <span>{{statusname}}</span>
          </div>
        </div>
      </div>
      <div class="detail">
        <div class="item">
          <span class="name">分类</span>
          <div class="input">
            <select v-model="baseInfo.id">
              <option :value="b.id" v-for="(b, i) in bases" :key="i">{{b.title}}</option>
            </select>
            <img src="@assets/img/resources/down.svg" alt="down" class="down">
          </div>
        </div>
        <div class="item">
          <span class="name">类型</span>
          <div class="input">
            <select v-model="classInfo.id">
              <option :value="c.id" v-for="(c, i) in classes" :key="i">{{c.title}}</option>
            </select>
            <img src="@assets/img/resources/down.svg" alt="down" class="down">
          </div>
        </div>
        <div class="item">
          <span class="name">名称</span>
          <span class="input">
            <input type="text" v-model="name">
          </span>
        </div>
        <div class="item">
          <span class="name">存放位置</span>
          <span class="input">
            <input type="text" v-model="locate">
          </span>
        </div>
        <div class="item">
          <span class="name">单价</span>
          <span class="input">
            <input type="text" v-model="price">
          </span>
        </div>
        <div class="item">
          <span class="name">报价单位</span>
          <span class="input">
            <input type="text" v-model="seller">
          </span>
        </div>
      </div>
      <div class="gps">
        <p class="title">GPS设备</p>
        <div class="item">
          <div class="block left">
            <img src="@assets/img/resources/gps.svg" alt="gps">
            <span class="name">GPS设备</span>
            <span class="value">{{gps.name}}</span>
          </div>
          <div class="block right">
            <img src="@assets/img/resources/locate.svg" alt="gps">
            <span class="name">位置</span>
            <span class="value">{{gps.locate}}</span>
          </div>
        </div>
        <div class="item">
          <div class="block left">
            <img src="@assets/img/resources/point.svg" alt="gps">
            <span class="name">坐标</span>
            <span class="value">{{gps.point}}</span>
          </div>
          <div class="block right">
            <img src="@assets/img/resources/time.svg" alt="gps">
            <span class="name">时间</span>
            <span class="value">{{gps.time}}</span>
          </div>
        </div>
      </div>
      <div class="remark">
        <span class="mark">
          备注
        </span>
        <textarea v-model="remark">
        </textarea>
        <span class="count">{{`${remark.length}/200`}}</span>
      </div>
    </div>
    <div class="about">
      <div class="toggler">
        <div :class="{toggle: true, on: toggleOn.id === t.id}" v-for="(t, i) in toggles" :key="i" @click="switchToggle(t)">
          {{t.title}}
        </div>
      </div>
      <div class="tasks" v-if="toggleOn.id === toggles[0].id">
        <div class="titleline">
          <span class="tag">使用类</span>
          <span class="title">使用主题</span>
          <span class="status">状态</span>
          <span class="user">司机编号</span>
          <span class="endTime">申请使用时间</span>
          <span class="exportTime">分配时间</span>
          <span class="releaseTime">手动取消／结束时间</span>
          <span class="handle">操作</span>
        </div>
        <empty :msg="'暂无相关任务'" v-if="tasks.length === 0" />
        <div class="content" v-for="(l, i) in tasks" :key="i">
          <div class="item">
            <span class="tag">
              <span class="mark">
                {{l.type_name}}
              </span>
            </span>
            <span class="theme" @click="goItv(l)">
              <p class="words">
                {{l.title}}
              </p>
            </span>
            <span class="status">{{l.status_name}}</span>
            <span class="user">
              <!-- {{l.persons.map(i => i.person_idstring).join(',')}} -->
              <i v-for="(u, i) in l.persons" :key="i">{{u.person_idstring}}</i>
            </span>
            <span class="endTime">
              <span>{{l.start}}</span>
              <span>{{l.end}}</span>
            </span>
            <span class="exportTime">{{l.opt_time}}</span>
            <span class="releaseTime">{{l.finish_time}}</span>
            <span :class="{handle: true}">
              <span v-if="l.status == 1" class="btn" @click="cancelTask(l.task_id)">
                取消
              </span>
              <span v-if="l.status == 2" class="btn" @click="endTask(l.task_id)">
                结束
              </span>
            </span>
          </div>
        </div>
      </div>
      <div class="records" v-if="toggleOn.id === toggles[1].id">
        <div class="titleline">
          <span class="title">出返库</span>
          <span class="time">操作时间</span>
          <span class="locate">外出地点</span>
          <span class="reporter">使用记者</span>
          <!-- <span class="tel">联系电话</span> -->
          <span class="task">相关任务</span>
          <span class="handler">操作者</span>
          <span class="check">设备检查</span>
        </div>
        <empty :msg="'暂无出返记录'" v-if="records.length === 0" />
        <div class="content" v-for="(l, i) in records" :key="i">
          <div class="item">
            <span class="title">
              <span class="mark">
                {{l.log_status_name}}
              </span>
            </span>
            <span class="time">{{l.opt_time}}</span>
            <span class="locate">{{l.address}}</span>
            <span class="reporter">
              <span v-for="(r, i) in l.users" :key="i">
                {{r}}
              </span>
            </span>
            <!-- <span class="tel">{{l.users}}</span> -->
            <span class="task">{{l.title}}</span>
            <span class="handler">{{l.opt_username}}</span>
            <span class="check">{{l.remark}}</span>
          </div>
        </div>
      </div>
      <pages :page_count="page.page_count" :index="page.pageIndex"></pages>
    </div>
    <div class="footline" :style="{width: `calc(100vw - ${footLineGap}px)`}">
      <div class="center">
        <div class="btn left" @click="delDevice()">删除设备</div>
        <div class="btn" @click="stopUse()">停用设备</div>
      </div>
      <div class="btn" @click="saveDevice()">保存设备</div>
      <div class="btn greenBtn" @click="exportRecords()">导出出返库记录</div>
    </div>
    <stopUse ref="stopUse" />
  </div>
</template>

<script>
import pages from '@components/pages'
import common from '@common/common'
import {apis} from '@common/config'
import empty from '@components/empty'
import stopUse from '@components/stopUse'

export default {
  name: 'equipmentDetail',
  components: {
    pages, empty, stopUse
  },
  computed: {
    baseId() {
      return this.baseInfo.id
    }
  },
  watch: {
    baseId(n) {
      this.changeClasses(n)
    }
  },
  data() {
    return {
      page: {
        page_count: 10,
        pageIndex: 1,
        pageSize: 10
      },
      username: '',
      statusname: '',
      title: '',
      remark: '',
      name: '',
      locate: '',
      price: '',
      seller: '',
      bases: [],
      classes: [],
      gps: {
        name: '',
        locate: '',
        point: '',
        time: ''
      },
      baseInfo: {
        id: '',
        title: ''
      },
      classInfo: {
        id: '',
        title: ''
      },
      toggles: [
        {
          title: '相关任务',
          id: 1
        },
        {
          title: '出返记录',
          id: 2
        }
      ],
      toggleOn: {},
      tasks: [],
      records: [],
      footLineGap: 230
    }
  },
  methods: {
    goItv(l) {
      if (l.relate_type != 0) return

      this.$router.push({
        path: '/interviewDetail',
        query: {
          r: l.relate_id
        }
      })
    },
    changeClasses(s) {
      // 切换分类，分类和类型联动，默认选择类型第一项, 如果有已选项则选已选项
      this.bases.forEach((i) => {
        if (s === i.id) {
          this.classes = i.list
          let selected = null
          this.classes.forEach(c => {
            if (c.selected) {
              selected = c
            }
          })
          selected = selected || this.classes[0]
          this.$set(this.classInfo, 'id', selected.id)
        }
      })
    },
    switchToggle(t) {
      this.toggleOn = t
      this.page.pageIndex = 1
      this.getList()
    },
    getDetail() {
      // 获取详情数据
      const id = this.$route.query.d
      const info = {
        device_id: id
      }

      common.myFetch(apis.Res_device_detail, info)
      .then((data) => {
        this.matchData(data.detail)
      })
    },
    matchData(data) {
      // 匹配数据到页面
      this.username = data.user_name
      this.statusname = data.status_name
      this.title = data.idstring
      this.name = data.title
      this.locate = data.location
      this.price = data.price
      this.seller = data.price_unit
      this.remark = data.remark
      this.bases = data.class_list
      this.gps = {
        name: data.gps.device_name,
        locate: data.gps.address,
        point: data.gps.location,
        time: data.gps.time
      }
      this.bases.forEach(i => {
        if (i.selected) {
          this.$set(this.baseInfo, 'id', i.id)
        }
      })
    },
    getList() {
      // 获取关联列表
      const type = this.toggleOn.id
      if (type === 1) {
        this.getTasks()
      } else {
        this.getRecords()
      }
    },
    getRecords() {
      // 获取出返记录
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_device_records, info)
      .then((data) => {
        this.records = data.list
        this.$set(this.page, 'page_count', common.calculatePage(data.pages.row_count - 0, this.page.pageSize))
      })
    },
    getTasks() {
      // 获取相关任务
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize
      }

      common.myFetch(apis.Res_device_uses, info)
      .then((data) => {
        this.tasks = data.list
        this.$set(this.page, 'page_count', common.calculatePage(data.page.row_count - 0, this.page.pageSize))
      })
    },
    cancelTask(id) {
      // 取消任务
      const info = {
        task_id: id
      }

      common.myFetch(apis.Res_device_task_cancel, info)
      .then((data) => {
        this.$toast(data)
      })
    },
    endTask(id) {
      // 结束任务
      this.$refs.stopUse.open(id)
    },
    delDevice() {
      // 删除设备
      const id = this.$route.query.d
      const info = {
        device_id: id,
        status: 1
      }

      common.myFetch(apis.Res_device_use, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
          window.history.go(-1)
        }
      })
    },
    stopUse() {
      // 停用设备
      const info = {
        device_id: this.$route.query.d,
        status: 0
      }

      common.myFetch(apis.Res_device_use, info)
      .then((data) => {
        if (data) {
          this.$toast(data)
        }
      })
    },
    saveDevice() {
      // 保存设备
      const device_id = this.$route.query.d
      const class_id = this.baseInfo.id
      const class_title = this.bases.map(i => {return i.id === class_id ? i.title : ''}).join('')
      const type_id = this.classInfo.id
      const type_title = this.classes.map(i => {return i.id === type_id ? i.title : ''}).join('')
      const title = this.name
      const location = this.locate
      const price_unit = this.seller
      const price = this.price

      const info = {
        device_id: device_id,
        class_id: class_id,
        class_title: class_title,
        type_id: type_id,
        type_title: type_title,
        title: title,
        location: location,
        price_unit: price_unit,
        price: price
      }

      common.myFetch(apis.Res_device_update, info)
      .then((data) => {
        this.$toast(data)
      })
    },
    exportRecords() {
      // 导出出返库记录
      const id = this.$route.query.d
      const info = {
        device_id: id,
        page: this.page.pageIndex,
        pagesize: this.page.pageSize,
        page_type: 'download'
      }
      const userKeys = common.userKeys()
      const params = Object.assign({}, info, userKeys)
      const url = apis.Res_device_records
      // const url = apis.Res_device_records + common.obj2Str(params)

      // window.open(url)
      common.exportRes(url, params)
    }
  },
  mounted() {
    this.switchToggle(this.toggles[0])
    this.getDetail()
  }
}
</script>

<style lang="less" src="@assets/css/resource/equipmentDetail.less" scoped>
</style>
